import { createContext, useContext } from 'react'

import { type CrossClientQueryResultDisplay } from '../../../models/CrossClient'

import { type CrmActionKind } from './crmActionRegistry'

export interface CrmActionHostOpenArgs {
  results: CrossClientQueryResultDisplay[]
}

export interface CrmActionHostContextValue {
  open: (kind: CrmActionKind, args: CrmActionHostOpenArgs) => void
  close: () => void
}

export const CrmActionHostContext = createContext<CrmActionHostContextValue | null>(null)

export const useCrmActionHost = (): CrmActionHostContextValue => {
  const ctx = useContext(CrmActionHostContext)
  if (!ctx) {
    throw new Error('useCrmActionHost must be used within a CrmActionHostProvider')
  }
  return ctx
}
